<template>
  <el-button :class="['record-btn', active ? 'active' : '']">
    <div class="record-btn-value">{{value}}</div>
    <div v-if="label" class="record-btn-label">{{label}}</div>
    <span v-if="show_delete" class="btn-icon" @click.stop="remove">
      <i class="el-icon-delete"></i>
    </span>
  </el-button>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    active: {
      type: Boolean,
      default: false
    },
    show_delete: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    remove() {
      this.$confirm('请再次确定是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$emit('remove');
      }).catch(() => {})
    }
  }
}
</script>
<style lang="less" scoped>
.record-btn{
  margin: 8px 0 0;
  position: relative;
  color: #808da2;
  font-weight: 500;
  text-align: left;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-right: 40px;
  +.record-btn{
    margin-left: 0;
  }
  &-value{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &-label{
    padding-top: 6px;
    font-size:14px;
    font-weight: 400;
    color: #808da2b3;
  }
  &:hover,
  &:focus {
    background: #eaf2ff;
    color: #4789f1;
    border-color: transparent;
    .record-btn-label{
      color: #4789f1;
    }
  }
  &.active {
    background: #eaf2ff;
    color: #4789f1;
    border-color: transparent;
    &::after {
      position: absolute;
      width: 4px;
      height: 50%;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      border-top-right-radius: 12px;
      border-bottom-right-radius: 12px;
      background: #4286f1;
      content: ' ';
    }
  }
}
</style>